const alertDivBaseClass = 'whale-edit-modal-alert';
export default class EditModal {
    constructor(eventTypes, timezone) {
        this.state = {
            visible: false,
            event: null
        }
        if (eventTypes) {
            this.typeSelect = this.getTypeSelect();
            this.eventTypes = eventTypes;
        }
        if (timezone) {
            this.timezone = timezone;
        }
        this.view = this.getDefaultView();
    }

    get event() {
        return this.state.event;
    }

    set event(event) {
        this.view.querySelector('.whale-edit-modal-header').textContent = event.title;
        // datetimes should be split into separate date and time inputs
        const startDateInput = this.view.querySelector('input[name="start-date"]');
        startDateInput.value = event.startDate.format('YYYY-MM-DD');
        const startTimeInput = this.view.querySelector('input[name="start-time"]');
        startTimeInput.value = event.startDate.format('HH:mm');
        if (this.eventTypes) {
            const typeSelect = this.view.querySelector('select.type-select');
            typeSelect.value = event.type;
        }

        this.state.event = event;
    }

    get eventTypes() {
        return this._eventTypes;
    }

    set eventTypes(eventTypes) {
        if (!(typeof eventTypes === 'object')) {
            throw Error('eventTypes must be an object or array');
        } else if (!(eventTypes instanceof Array)) {
            eventTypes = Object.keys(eventTypes);
        }
        this.typeSelect.innerHTML = '';
        eventTypes.forEach((type) => {
            let option = document.createElement('option');
            option.textContent = type;
            this.typeSelect.append(option);
        })
        this._eventTypes = eventTypes;
    }

    get view() {
        return this._view;
    }

    set view(view) {
        this._view = view;
    }

    getDefaultView() {
        const editModal = document.createElement('div');
        editModal.className = 'whale-edit-modal';
        editModal.style.display = 'none';

        const editModalOverlay = document.createElement('div');
        editModalOverlay.className = 'whale-edit-modal-overlay';
        editModalOverlay.addEventListener('click', this.handleClose.bind(this));
        editModal.append(editModalOverlay);

        const editModalContent = document.createElement('div');
        editModalContent.className = 'whale-edit-modal-content form-group';

        const editModalHeaderWrapper = document.createElement('div');
        editModalHeaderWrapper.className = 'col-sm-12'; // Bootstrap
        editModalContent.append(editModalHeaderWrapper);

        const editModalHeader = document.createElement('h4');
        editModalHeader.className = 'whale-edit-modal-header';
        editModalHeaderWrapper.append(editModalHeader);

        const alertDiv = document.createElement('div');
        alertDiv.className = alertDivBaseClass;
        editModalHeaderWrapper.append(alertDiv);
        this.alertDiv = alertDiv;

        const editModalInputs = document.createElement('div');
        editModalInputs.className = 'whale-edit-modal-inputs';
        editModalContent.append(editModalInputs);

        const columnDiv1 = document.createElement('div');
        columnDiv1.className = 'col-sm-6'; // Bootstrap
        editModalInputs.append(columnDiv1);

        const columnDiv2 = document.createElement('div');
        columnDiv2.className = 'col-sm-6'; // Bootstrap
        editModalInputs.append(columnDiv2);

        if (this.typeSelect) {
            // Input for Event Types
            let typeLabel = document.createElement('label');
            typeLabel.htmlFor = 'type-select';
            typeLabel.textContent = 'Type';
            this.typeSelect.addEventListener('input', this.handleInput.bind(this));
            columnDiv1.append(typeLabel);
            columnDiv1.append(this.typeSelect);
            // select options are added by the set eventTypes method
        }

        // Input for Start Date
        let dateLabel = document.createElement('label');
        dateLabel.htmlFor = 'start-date';
        dateLabel.textContent = 'Start Date';
        columnDiv2.append(dateLabel);

        const dateInput = document.createElement('input');
        dateInput.type = 'date';
        dateInput.name = 'start-date';
        dateInput.className = 'form-control no-padding start-date'; // Bootstrap
        dateInput.addEventListener('input', this.handleInput.bind(this));
        columnDiv2.append(dateInput);

        // Input for End Date
        let timeLabel = document.createElement('label');
        timeLabel.htmlFor = 'start-time';
        timeLabel.className = 'hidden';
        timeLabel.textContent = 'Start Time';
        columnDiv2.append(timeLabel);

        const timeInput = document.createElement('input');
        timeInput.type = 'time';
        timeInput.name = 'start-time';
        timeInput.className = 'form-control hidden start-time'; // Bootstrap
        timeInput.addEventListener('input', this.handleInput.bind(this));
        columnDiv2.append(timeInput);

        const buttonWrapper = document.createElement('div');
        buttonWrapper.className = 'col-sm-12 text-right'; // Bootstrap

        const saveButton = document.createElement('button');
        saveButton.textContent = 'Save';
        saveButton.setAttribute('disabled', 'disabled');
        saveButton.className = 'whale-edit-modal-save whale-save-btn btn'; // Bootstrap
        saveButton.addEventListener('click', this.handleSubmit.bind(this));

        const cancelButton = document.createElement('button');
        cancelButton.textContent = 'Cancel';
        cancelButton.className = 'whale-edit-modal-cancel btn btn-default'; // Bootstrap
        cancelButton.addEventListener('click', this.handleClose.bind(this));

        const closeButton = document.createElement('button');
        closeButton.textContent = '×';
        closeButton.className = 'whale-edit-modal-close';
        closeButton.addEventListener('click', this.handleClose.bind(this));

        buttonWrapper.append(saveButton);
        buttonWrapper.append(cancelButton);
        editModalContent.append(buttonWrapper);
        editModalContent.append(closeButton);
        editModal.append(editModalContent);
        return editModal;
    }

    getTypeSelect() {
        const typeSelect = document.createElement('select');
        typeSelect.name = 'type-select';
        typeSelect.className = 'form-control type-select';
        // select options are added by the set eventTypes method
        return typeSelect;
    }

    toggle() {
        if (this.event === null) {
            throw Error('Modal must have an instance of WhaleCalendar Event to be toggled');
        }
        if (this.state.visible) {
            this.resetAlert();
            this.view.style.display = 'none';
        } else {
            this.view.style.display = 'inherit';
        }
        this.state.visible =  !this.state.visible;
    }

    handleSubmit(e) {
        const values = {};
        var newStartDate;
        const startDateInput = this.view.querySelector('input[name="start-date"]');
        if (startDateInput.validity.badInput) {
            this.toggle();
            throw Error(`${startDateInput.value} is not valid! Pick a valid date!`);
        }
        const startTimeInput = this.view.querySelector('input[name="start-time"]');
        if (startTimeInput.validity.badInput) {
            this.toggle();
            throw Error(`${startTimeInput.value} is not valid! Pick a valid time!`);
        }
        const newStartDateString = `${startDateInput.value} ${startTimeInput.value}`;
        if (this.timezone) {
            newStartDate = moment(newStartDateString + this.timezone, "YYYY-MM-DD HH:mmZZ");
        } else {
            newStartDate = moment(newStartDateString, "YYYY-MM-DD HH:mm");
        }
        if (newStartDateString != this.event.startDate.format("YYYY-MM-DD HH:mm")) {
            values.startDate = newStartDate;
        }

        if (this.eventTypes) {
            const typeSelect = this.view.querySelector('select.type-select');
            if (typeSelect.value != this.event.type) {
                values.type = typeSelect.value;
            }
        }
        let submitSucceedFlag = true;
        if (this.submitCallback) {
            // if the callback returns false, do not close the modal.
            submitSucceedFlag = this.submitCallback(e, this.event, values);
        }
        if (submitSucceedFlag !== false) {
            this.toggle();
        }
    }

    handleClose(e) {
        this.toggle();
        const saveButton = this.view.querySelector('button.whale-edit-modal-save');
        saveButton.setAttribute('disabled', 'disabled');
        if (this.closeCallback) {
            this.closeCallback(e, this.event);
        }
    }

    handleInput(e) {
        const saveButton = this.view.querySelector('button.whale-edit-modal-save');
        saveButton.removeAttribute('disabled');
    }

    displayAlert(message, className) {
        if (!this.state.visible) {
            this.toggle();
        }
        this.alertDiv.className = `${alertDivBaseClass} ${className}`
        this.alertDiv.textContent = message;
    }
    resetAlert() {
        this.alertDiv.className = alertDivBaseClass
        this.alertDiv.textContent = '';
    }
}
